// API 配置
const getBaseURL = () => {
  // 优先使用环境变量
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL
  }
  
  // 开发环境使用 localhost
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001/api'
  }
  
  // 生产环境 - 这里需要您的后端地址
  // 如果没有部署后端，返回 null 来使用模拟数据
  return null
}

export const API_CONFIG = {
  baseURL: getBaseURL(),
  timeout: 10000,
  
  // 检查是否有可用的后端
  hasBackend: () => {
    return getBaseURL() !== null
  }
}

export default API_CONFIG
